import { IbackofficeUserData } from 'types/configuration.types';
import { IBulkUploadCatalogApi, IBulkUploadOrderApi, IBulkUploadHistoryItem } from './TypeOfCharge.types';

enum BULK_UPLOAD_API_TYPE {
  'productos' = 1,
  'órdenes' = 2
}

enum BULK_UPLOAD_API_CATEGORY {
  'Catálogo de producto' = 1,
  'Órdenes' = 2
}

export const mapCatalogUploadHistoryData = (
  data: IBulkUploadCatalogApi[],
  usersData: IbackofficeUserData[]
): IBulkUploadHistoryItem[] => {
  const usersMap = new Map(usersData.map(user => [user.id, user]));
  return data.map(item => {
    const user = usersMap.get(item.userId!);
    return {
      category: BULK_UPLOAD_API_CATEGORY[item.bulkUploadType.id] || '',
      date: new Date(item.createdAt).toLocaleString('es-ES', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }),
      loadId: item.id,
      responsible: {
        firstName: user?.firstName || '',
        lastName: user?.lastName || '',
        email: user?.email || '',
        avatar: user?.photoProfile || ''
      },
      loadStatus: {
        success: item.productsUpdated,
        total: item.productsUploaded,
        typeOfCharge: BULK_UPLOAD_API_TYPE[item.bulkUploadType.id]
      },
      template: item.fileUrl
    };
  });
};

export const mapOrdersUploadHistoryData = (data: IBulkUploadOrderApi[], usersData: IbackofficeUserData[]): IBulkUploadHistoryItem[] => {
  const usersMap = new Map(usersData.map(user => [user.id, user]));
  return data.map(item => {
    const user = usersMap.get(item.userId!);
    return {
      category: 'Órdenes',
      date: new Date(item.createdAt).toLocaleString('es-ES', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }),
      loadId: item.id,
      responsible: {
        firstName: user?.firstName || '',
        lastName: user?.lastName || '',
        email: user?.email || '',
        avatar: user?.photoProfile || ''
      },
      loadStatus: {
        success: item.createdRecords,
        total: item.totalRecords,
        typeOfCharge: 'órdenes'
      },
      template: item.fileUrl
    };
  });
};
